import { ParamsContext } from "context/ViewContext/ParamsContext";
import { useProviderInitializedContext } from "./useProviderInitializedContext";

export const useParams = () => {
  return useProviderInitializedContext(ParamsContext);
};
